import { render, staticRenderFns } from "./AssignDealer.vue?vue&type=template&id=2a7b154a"
import script from "./AssignDealer.vue?vue&type=script&lang=js"
export * from "./AssignDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports